import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";
import { api, API_BASE, formatApiError } from "../lib/api";

export default function ImageUpload({ label, value, onChange, testid }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Please choose an image file");
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      toast.error("Image must be under 10 MB");
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/upload", fd);
      onChange(`/api/media/${r.data.path}`);
      toast.success("Photo uploaded");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8A857D]">{label}</span>
      <div className="mt-1.5 flex items-center gap-3 flex-wrap">
        {value && (
          <div className="relative">
            <img src={value} alt="" className="h-16 w-24 object-cover border border-[#181816]/15" data-testid={testid ? `${testid}-preview` : undefined} />
            <button
              type="button"
              onClick={() => onChange("")}
              className="absolute -top-2 -right-2 bg-[#181816] text-[#F8F6F0] p-1"
              aria-label="Remove photo"
              data-testid={testid ? `${testid}-clear` : undefined}
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        )}
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          data-testid={testid}
          className="inline-flex items-center gap-2 border border-[#181816]/20 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.18em] hover:border-[#181816] disabled:opacity-50 transition-colors"
        >
          <Upload className="h-3.5 w-3.5" /> {busy ? "Uploading…" : value ? "Replace Photo" : "Upload Photo"}
        </button>
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid={testid ? `${testid}-input` : undefined} />
      </div>
      <input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="…or paste an image URL"
        className="mt-2 w-full bg-white border border-[#181816]/15 px-3 py-2 text-xs font-light focus:border-[#181816] transition-colors"
      />
    </div>
  );
}
